import {
  NEW_PASSOWRD_REQUEST,
  NEW_PASSOWRD_SUCCESS,
  NEW_PASSOWRD_FAILURE,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  successfully: false,
};

const forgotPassword = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case NEW_PASSOWRD_REQUEST:
      return {
        ...state,
        loading: true,
        successfully: false,
      };
    case NEW_PASSOWRD_SUCCESS:
      return {
        ...state,
        loading: false,
        successfully: true,
      };
    case NEW_PASSOWRD_FAILURE:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default forgotPassword;
